import React, { useEffect, useState } from "react";
import {
  useReactTable,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  getFilteredRowModel,
  flexRender,
} from "@tanstack/react-table";
import { useNavigate } from "react-router-dom";


const ReusableTable = ({ data, hyperLink }) => {
  const [globalFilter, setGlobalFilter] = useState(""); // Global search
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [columns, setColumns] = useState([]);
  const navigate = useNavigate();
  
  const processJsonData = (jsonData) => {
          if (jsonData.length === 0) return;
          // Extract column headers dynamically
          const rawHeaders = Object.keys(jsonData[0]);
          // Determine column types based on unique values
      //     const columnValueSets = {};
      //     jsonData.forEach((row) => {
      //     Object.entries(row).forEach(([key, value]) => {
      //         if (!columnValueSets[key]) columnValueSets[key] = new Set();
      //         columnValueSets[key].add(value);
      //     });
      // });
      const headers = rawHeaders.map((col) => {
          return {
              accessorKey: col,
              header: col,
              cell: (info) => {
                const value = info.getValue();
                if (col.toLowerCase() === "name" && hyperLink) {
                  return (
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault(); // Prevent default link behavior
                        // navigate(`/details/${value}`); // Redirect to details page
                        navigate("/view-data", {
                          state: { selectedSource: value  }, // Passing values to next page
                        });
                      }}
                      style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                    >
                      {value}
                    </a>
                  );
                }
                return value;
              },
          };
        });
      setColumns(headers);
      // setData(jsonData);
      };

     useEffect(() => {
        processJsonData(data);
      }, []);

  const table = useReactTable({
      data: data,
      columns,
      state: { sorting, pagination, globalFilter },
      onSortingChange: setSorting,
      onPaginationChange: setPagination,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
      getPaginationRowModel: getPaginationRowModel(),
      onGlobalFilterChange: setGlobalFilter,
      getFilteredRowModel: getFilteredRowModel(),
    });
  
  return (
      <div className="container mt-4">
        <input
          type="text"
          placeholder="Global Search..."
          value={globalFilter}
          onChange={(e) => setGlobalFilter(e.target.value)}
          style={{ marginBottom: "10px", padding: "5px" }}
        />
        <div className="table-responsive" style={{ overflowX: "auto",width: "100%", maxWidth: "100%",overflowY: "auto", maxHeight: "300px" }}>
          <table className="table table-striped table-hover table-bordered" style={{ width: "100%", borderCollapse: "collapse", border: "1px solid black" }}>
            <thead className="table-light" style={{ position: "sticky", top: 0, background: "#f4f4f4", zIndex: 2 }}>
              {table.getHeaderGroups().map(headerGroup => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map(header => (
                    <th
                      key={header.id}
                      onClick={header.column.getToggleSortingHandler()}
                      className="text-center"
                      style={{ cursor: "pointer" }}
                    >
                      {flexRender(header.column.columnDef.header, header.getContext())}
                      {header.column.getIsSorted() ? (header.column.getIsSorted() === "asc" ? " 🔼" : " 🔽") : ""}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.length > 0 ? (
                table.getRowModel().rows.map(row => (
                  <tr key={row.id}>
                    {row.getVisibleCells().map(cell => (
                      <td key={cell.id} className="text-center">
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length} className="text-center">
                    No records found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
  
        {/* Bootstrap Pagination */}
        <nav>
          <ul className="pagination justify-content-center">
            <li className={`page-item ${!table.getCanPreviousPage() && "disabled"}`}>
              <button onClick={() => table.setPageIndex(0)} className="page-link">⏮ First</button>
            </li>
            <li className={`page-item ${!table.getCanPreviousPage() && "disabled"}`}>
              <button onClick={() => table.previousPage()} className="page-link">◀ Prev</button>
            </li>
            
            {/* Page Dropdown */}
            <li className="page-item active">
              <span className="page-link d-flex align-items-center">
                Page&nbsp;
                <select
                  className="form-select form-select-sm mx-2"
                  style={{ width: "60px" }} // Keeps it compact
                  value={pagination.pageIndex}
                  onChange={(e) => setPagination((prev) => ({ ...prev, pageIndex: Number(e.target.value) }))}
                >
                  {Array.from({ length: table.getPageCount() }, (_, index) => (
                    <option key={index} value={index}>
                      {index + 1}
                    </option>
                  ))}
                </select>
                of {table.getPageCount()}
              </span>
            </li>

            <li className={`page-item ${!table.getCanNextPage() && "disabled"}`}>
              <button onClick={() => table.nextPage()} className="page-link">Next ▶</button>
            </li>
            <li className={`page-item ${!table.getCanNextPage() && "disabled"}`}>
              <button onClick={() => table.setPageIndex(table.getPageCount() - 1)} className="page-link">⏭ Last</button>
            </li>
              {/* Page Size Dropdown - Now Below Pagination */}
           <li>
              <label className="me-2">Rows per page:</label>
              <select
                className="form-select d-inline-block w-auto"
                value={pagination.pageSize}
                onChange={(e) => setPagination({ ...pagination, pageSize: Number(e.target.value) })}
              >
                {[5, 10, 15, 20, 25, 50].map((size) => (
                  <option key={size} value={size}>
                    {size}
                  </option>
                ))}
              </select>
            </li>
          </ul>
        
        </nav>
      </div>
    );

};

export default ReusableTable;
